import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import clsx from 'clsx';

export default function BlogPostMediaImage(blok) {
  const { image, image_dark: imageDark, articleTitle } = blok;

  const {
    title,
    filename,
    // focus,
    copyright,
    // fieldtype,
    name,
    alt,
    source,
  } = image;

  let imageAlt = alt !== '' ? alt : title;
  imageAlt = imageAlt !== '' ? imageAlt : name;
  imageAlt = imageAlt !== '' ? imageAlt : copyright;
  imageAlt = filename && imageAlt !== '' ? imageAlt : `${filename.split('/').at(-1).split('.')[0]} (${articleTitle})`;

  const [, setTheme] = React.useState();
  const [_filename, setFilename] = React.useState();

  const handleThemeChange = React.useCallback((event) => {
    const { theme } = event;
    setTheme(theme);
    setFilename(theme === 'dark' && imageDark && imageDark.filename ? imageDark.filename : filename);
  }, [filename, imageDark, setTheme]);

  React.useEffect(() => {
    window.addEventListener('handleThemeChange', handleThemeChange);
    return () => {
      window.removeEventListener('handleThemeChange', handleThemeChange);
    };
  }, [handleThemeChange]);

  React.useEffect(() => {
    handleThemeChange({ theme: document.body.classList.contains('dark') ? 'dark' : 'light' });
  }, [handleThemeChange]);

  if (!image.filename) {
    return null;
  }

  const [width, height] = filename.split('/')[5].split('x');

  const styles = clsx(
    'blok-blogpost-media-image my-8',
  );

  const fileNameToSize = (url, size) => url.replace('https://a.storyblok.com', `https://img2.storyblok.com/${size}x`);

  if (!_filename) return null;

  return (
    <figure {...storyblokEditable(blok)} className={styles}>
      <img
        src={fileNameToSize(_filename, 2000)}
        alt={imageAlt}
        srcSet={`
          ${fileNameToSize(_filename, 200)} 200w,
          ${fileNameToSize(_filename, 300)} 300w,
          ${fileNameToSize(_filename, 400)} 400w,
          ${fileNameToSize(_filename, 500)} 500w,
          ${fileNameToSize(_filename, 600)} 600w,
          ${fileNameToSize(_filename, 700)} 700w,
          ${fileNameToSize(_filename, 800)} 800w,
          ${fileNameToSize(_filename, 900)} 900w,
          ${fileNameToSize(_filename, 1000)} 1000w,
          ${fileNameToSize(_filename, 1100)} 1100w,
          ${fileNameToSize(_filename, 1200)} 1200w,
          ${fileNameToSize(_filename, 1300)} 1300w,
          ${fileNameToSize(_filename, 1400)} 1400w,
          ${fileNameToSize(_filename, 1500)} 1500w,
          ${fileNameToSize(_filename, 1600)} 1600w,
          ${fileNameToSize(_filename, 1700)} 1700w,
          ${fileNameToSize(_filename, 1800)} 1800w,
          ${fileNameToSize(_filename, 1900)} 1900w`}
        width={width}
        height={height}
        loading="lazy"
      />
      {source && (
        <div className="text-xs text-gray-400">{source}</div>
      )}
      {title && (
        <figcaption>{title}</figcaption>
      )}
    </figure>
  );
}
